module.exports = __webpack_public_path__ + "img/Lobby_Video.6cb1a7e0.jpg";